import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import './Modal.css';

type Project = {
  category: string;
  grade: string;
  title: string;
  description: string;
  color: string;
};

interface CustomModalProps {
  project?: Project | null;
  show?: boolean;
  setShow?: (value: boolean) => void;
  onHide?: () => void;
}

function CustomModal({ project, show = false, setShow, onHide }: CustomModalProps) {
  const handleClose = () => {
    setShow?.(false);
    onHide?.();
  };

  return (
    <Modal show={show} onHide={handleClose} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>{project?.title ?? 'Project details'}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {project ? (
          <>
            <p><strong>{project.category}</strong></p>
            <p><strong>Grade:</strong> {project.grade}</p>
            <p>{project.description}</p>
          </>
        ) : (
          <p>No project selected.</p>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default CustomModal;
